export default __webpack_public_path__ + "static/media/crown.ea648388.svg";